import { render, staticRenderFns } from "./childImmunity.vue?vue&type=template&id=21444eca&scoped=true"
import script from "./childImmunity.vue?vue&type=script&lang=js"
export * from "./childImmunity.vue?vue&type=script&lang=js"
import style0 from "./childImmunity.vue?vue&type=style&index=0&id=21444eca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21444eca",
  null
  
)

export default component.exports